import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Label = styled.p`
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  color: ${props => props.theme.colors.text.default};
  margin: 0;
  margin-bottom: ${props => props.theme.spacing.sp8};
`
